import { FlowSheetEditor } from "@/components/FlowSheetEditor/FlowSheetEditor"
import { contentIsValid, resetImagesToNodes } from "@/components/FlowSheetEditor/services/resetCells"
import { getEmptyFlowSheetContent } from "@/components/FlowSheetEditor/services/storage"
import { FlowSheet, getFSTemplate, getFlowFile, updateFlowSheetFile, updateTemplate} from "@/services/project/flowsheets"
import { useEffect, useMemo, useRef, useState } from "react"
import { useMatch } from "react-router"
import { tagGenerator } from "@/components/FlowSheetEditor/services/TagGenerator"
import { useDispatch } from "react-redux"
import { setFSContent, setSetOperations, setSpreadsheets, updateTemplate as updateTemplateAction  } from "@/store/flowsheet/flowsheet.slice"
import { message } from "antd"
import { DataContainer } from "./DataContainer"
import { contentUnitConvertToMM, contentUnitConvertToPX } from "./helper"
import { doMigration } from "@/components/FlowSheetEditor/migration"
import { useHasPermissions } from "@/components/OPermission/OPermission"
import { ROLE_DRAFTER } from "@/components/OPermission/PlanPermission"

export function FlowSheetPage() {
  const match = useMatch('/main/projects/:projectId/:type/:id')
  const id = match?.params.id || ''
  const isTemplate = match?.params.type === 'templates'
  const projectId = match?.params.projectId || ''
  // const { data, loading } = useRequest(() => isTemplate ? getFSTemplate(id) : getFlowFile(id))
  const [data, setData] = useState<FlowSheet.Modal | null>(null)
  const dataRef = useRef<any>(null)
  const dispatch = useDispatch()
  const hasPermission = useHasPermissions()

  useEffect(() => {
    let dataPromise;
    if (isTemplate) {
      dataPromise = getFSTemplate(id)
    } else {
      dataPromise = getFlowFile(id)
    }
    dataPromise.then((res) => {
      setData(res)
    })
  }, [isTemplate, id])

  useEffect(() => {
    if (!data) return
    if (!isTemplate && data.tempContent) {
      const tempContent = JSON.parse(data.tempContent)
      dispatch(updateTemplateAction(tempContent.template || {}))
    }
    if (!data.content) {
      tagGenerator.init({})
      dispatch(setFSContent(getEmptyFlowSheetContent()))
      return
    }
    const content = contentUnitConvertToPX(doMigration(JSON.parse(data.content)))
    dispatch(setSetOperations(content.setOperations || []))
    dispatch(setSpreadsheets(content.spreadsheets || []))
    if (isTemplate) dispatch(updateTemplateAction(content.template || {}))
    tagGenerator.init(content.tagState || {})
    dispatch(setFSContent(resetImagesToNodes(content)))
  }, [data, dispatch])

  const saveFileContent = async (content) => {
    if (!hasPermission(ROLE_DRAFTER)) {
      return;
    }
    if (!contentIsValid(content)) {
      message.error('Save content failed, The conent is not valid.')
      return;
    }
    const contentStr = JSON.stringify(contentUnitConvertToMM(content))
    if (dataRef.current === contentStr) {
      return;
    }
    if (isTemplate) {
      await updateTemplate({...data, content: contentStr}, {id: data!.id})
    } else {
      await updateFlowSheetFile({...data, content: contentStr}, {id: data!.id})
    }
    dataRef.current = contentStr
  }

  const template = useMemo(() => {
    if (!data) return
    if (!data.tempContent) {
      return
    }
    return contentUnitConvertToPX(JSON.parse(data.tempContent))
  }, [data])

  if (!projectId || !data) return null
  return <>
    <FlowSheetEditor isTemplate={isTemplate} template={template} onSave={saveFileContent} />
    {!isTemplate && <DataContainer fsId={id} projectId={projectId}/>}
  </>
}